export enum ButtonType {
  Button = 'button',
  Submit = 'submit',
  Reset = 'reset',
}

export interface ButtonInteractiveProps {
  // Base
  id?: number;
  text?: string;

  // BaseControls
  isDisabled?: boolean;
  isActive?: boolean;
  isFocused?: boolean;
  tabIndexValue?: number;
  ariaCurrent?: 'page' | 'step' | 'location' | 'date' | 'time' | boolean;
  ariaControls?: string;
  isExpanded?: boolean;
  icon?: string;
  isVisible?: boolean;

  // Accessibility
  ariaLabel?: string;
  ariaDescribedBy?: string;
  role?: string;

  // Interactive
  requiresConfirmation?: boolean;
  confirmationMessage?: string;
  isAsync?: boolean;
  isLoading?: boolean;

  // ButtonInteractive specific
  link?: string;
  buttonType?: ButtonType;
  isToggle?: boolean;
}
